import { render, staticRenderFns } from "./AppFeatureItem.vue?vue&type=template&id=58bf8cd5&scoped=true"
import script from "./AppFeatureItem.vue?vue&type=script&lang=coffee"
export * from "./AppFeatureItem.vue?vue&type=script&lang=coffee"
import style0 from "./AppFeatureItem.vue?vue&type=style&index=0&id=58bf8cd5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0_supports-_a02809e54f1429825a019cd6b08a4fe2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bf8cd5",
  null
  
)

export default component.exports